export default  {

  validateLoginName: function(rule, value, callback) {
    if (!value) {
      callback(new Error('用户名不能为空'));
    }
    if (/^[a-zA-Z0-9_]{6,16}$/.test(value)) {
      return callback();
    } else {
      return callback(new Error('用户名2到16位（字母，数字，下划线）'));
    }
  },

  validateName: function(rule, value, callback) {
    if (!value) {
      return callback(new Error('姓名不能为空'));
    }
    // 昵称正则，2到20位中文，字母，数字，下划线
    if (/^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/.test(value)) {
      return callback();
    } else {
      return callback(new Error('姓名格式错误'));
    }
  },

  validatePasswordStrong: function(rule, value, callback) {
    if (!value) {
      return callback(new Error('密码不能为空'));
    }
    if (/^.*(?=.{8,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/.test(value)) {
      return callback();
    } else {
      return callback(new Error('密码长度最少8位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符'));
    }
  },

  validatePasswordWeak: function(rule, value, callback) {
    if (!value) {
      return callback(new Error('密码不能为空'));
    } else {
      return callback();
    }
    // 弱密码强度正则，最少6位，包括至少1字母，1个数字
    /*if (/^.*(?=.{6,})(?=.*\d)(?=.*[A-Za-z]).*$/.test(value)) {
      return callback();
    } else {
      return callback(new Error('密码最少6位，包含至少1字母和1个数字'));
    }*/
  },

  validateMobile: function(rule, value, callback) {
    if (!value) {
      return callback?callback(new Error('手机号不能为空')) : false;
    }
    // 手机号正则，11位数字，1开头
    if (/^1\d{10}$/.test(value)) {
      return callback?callback() : true;
    } else {
      return callback?callback(new Error('手机号格式错误')) : false;
    }
  },

  validateImageCode: function(rule, value, callback) {
    if (!value) {
      return callback(new Error('图形验证码不能为空'));
    }
    // 图片验证码正则，4位字母，数字
    if (/^[a-zA-Z0-9]{4}$/.test(value)) {
      return callback();
    } else {
      return callback(new Error('图形验证码格式错误'));
    }
  },

  validateMobileCode: function(rule, value, callback) {
    if (!value) {
      return callback(new Error('短信验证码不能为空'));
    }
    // 手机验证码正则，6位数字
    if (/^[0-9]{6}$/.test(value)) {
      return callback();
    } else {
      return callback(new Error('请输入6位数值的短信验证码'));
    }
  },

  validateIdNum: function(rule, value, callback) {
    if (!value) {
      return callback(new Error('身份证号不能为空'));
    }
    // 去除首尾空格及不可见字符
    value = value.replace(/\s+/g, '').replace(/[\u200b\u200c\u200d\ufeff]/g, '');
    // 大陆18位身份证号
    const mainlandId = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    // 港澳居民身份证：1-2位字母 + 6位数字 + 括号内1位校验码，如 A123456(7)，兼容中英文括号和大小写字母
    const hkid = /^[A-Za-z]{1,2}\d{6}[\(（]\d[\)）]$/;
    // 旧版回乡证：11位纯数字
    const oldHxPermit = /^\d{11}$/;
    // 新版回乡证（港澳居民来往内地通行证）：H或M + 8位或10位数字
    const newHxPermit = /^[HhMm]\d{8}(\d{2})?$/;
    // 其他：4位至20位
    const anyNum = /^.{4,20}$/;
    if (mainlandId.test(value) || hkid.test(value) || oldHxPermit.test(value) || newHxPermit.test(value) || anyNum.test(value)) {
      return callback();
    } else {
      return callback(new Error('身份证号格式错误'));
    }
  },

  validateExamNo: function(rule, value, callback) {
    if (!value) {
      return callback(new Error('准考证号不能为空'));
    }
    if (/\s+/.test(value)) {
      return callback(new Error('准考证号不能有空格'));
    }
    // 准考证号只能是数字
    if (/^[0-9a-zA-Z-_]+$/.test(value)) {
      return callback();
    } else {
      return callback(new Error('准考证号格式不正确'));
    }
  }

};
